class ReviewCarousel extends HTMLElement {
  constructor() {
    super();

    this.observerIntersection = null;
  }

  connectedCallback() {
    this.observerIntersection = new IntersectionObserver(
      this.observationCallback.bind(this),
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    this.observerIntersection.observe(this);
  }

  disconnectedCallback() {
    if (this.observerIntersection) {
      this.observerIntersection.disconnect();
    }
  }

  observationCallback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.initOkendoCarousel();
        observer.unobserve(entry.target);
      }
    });
  }

  initOkendoCarousel() {
    const isOkendoWidgetInit = this.getAttribute('data-okendo-init');

    if (isOkendoWidgetInit === 'true') {
      console.info('Okendo Carousel Already initialzed');

      return null;
    }

    if (
      !window.okeWidgetApi &&
      typeof window.okeWidgetApi?.initWidget !== 'function'
    ) {
      console.warn('Okendo Widget API Missing');

      return null;
    }

    if (
      window.okeWidgetApi &&
      typeof window.okeWidgetApi.initWidget === 'function'
    ) {
      this.setAttribute('data-okendo-init', 'true');
      this.setAttribute('data-oke-carousel', '');
      window.okeWidgetApi.initWidget(this, true);
      console.info('Okendo Widget Carousel Done Initializing');
    }
  }
}

customElements.define('reviews-carousel', ReviewCarousel);
